

import { z } from "zod";
import type { AssertSchemaMatchesClass } from "../../../utils/typeUtils";
import { RiskFrequenciesWithNA } from "../Risk";
import { Hazard } from "../Hazard";


const _HazardZod = z.object({
  hazard_id: z.string().default(""),
  label: z.string().default(""),
  description: z.string().default(""),
  likelihood: z.enum(RiskFrequenciesWithNA).default("n/a")
})

// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _HazardZod, Hazard>);

export const HazardSchema = _HazardZod.transform((data) => new Hazard(data));

